module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/left_icon-ae1b26b0067b1ec8cc684062c77dfc77.png";